import { useState } from 'react';
import { cssVar } from '@going-once/tokens';
import { focusRing, Text } from './primitives';

/**
 * **A checkbox with its label** (the design system's `Checkbox`): a native `<input type="checkbox">`, so
 * Space flips it and a screen reader says "checked", drawn in the accent through `accent-color`. The label
 * is part of the target, and the whole row is at least a touch target tall.
 */
export function Checkbox({
  id,
  label,
  checked,
  onChange,
  disabled,
}: {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}) {
  const [focused, setFocused] = useState(false);
  return (
    <label
      htmlFor={id}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: cssVar('space.md'),
        minHeight: cssVar('size.target.min'),
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
        onFocus={(event) => setFocused(event.currentTarget.matches(':focus-visible'))}
        onBlur={() => setFocused(false)}
        style={{
          flex: 'none',
          width: cssVar('space.lg'),
          height: cssVar('space.lg'),
          margin: 0,
          accentColor: cssVar('color.accent.default'),
          cursor: 'inherit',
          ...(focused ? focusRing : {}),
        }}
      />
      <Text>{label}</Text>
    </label>
  );
}
